angular
  .module("userManagementAra.components", [])
  .component("userManagementAra", {
    templateUrl: "ng/components/userManagementAra/userManagementAra.view.html",
    controllerAs: "userManagementAraCtrl",
    bindings: {
      configObj: "<",
      isFromAra: "<",
      isFromAraUtenze: "<",
    },
    controller: function (
      $scope,
      HttpService,
      $rootScope,
      validationService,
      $searchUserService,
      $simulationService,
      FactoryObj,
      $filter,
      $monitoringService,
      $featureService,
      $configService,
      $modalService,
      $userService,
      $location,
      $storageService,
      $arcService,
      $portalService,
      $timeout,
      $download

    ) {
      var self = this;

      self.$onChanges = function (changes) {
        if (
          changes.configObj &&
          changes.configObj.currentValue.selectedAppCustomerUser
        ) {
          self.researchObjAraVariable.piva =
            changes.configObj.currentValue.selectedAppCustomerUser.identifier;
        }

        if (
          changes.configObj &&
          changes.configObj.currentValue.customerListAra
        ) {
          self.customerList = changes.configObj.currentValue.customerListAra;
        }
      };

      self.$onInit = function () {
        self.userLogged = $configService.getUser();
        self.path = $configService.getUrl();
        self.$portalService = $portalService;
        $scope.AralSimulationRi = $featureService.AralSimulationRi();
        $scope.ArfPrintContractDetail = $featureService.ArfPrintContractDetail();
        self.loading = false;
        self.searchReturned = false; // after rest call
        self.validationService = validationService;
        self.searchUserService = $searchUserService;
        self.configObj.showDetailedView = false;
        self.configObj.showOnlyInfoDetails = false;
        self.configObj.showNewAppCustomerForm = false;
        self.configObj.goToSelectedAppCustomerDetails =
          self.saveAppCustomerGfromSearch;
        self.configObj.goBackToSearchForm = self.goBackToSearchForm;
        self.configObj.goToInfoAppCustomer = self.goToInfoAppCustomer;
        self.configObj.goToManagementAppCustomer =
          self.goToManagementAppCustomer;
        self.searchUserObj = {};
        self.customerListSortKey = "ragSoc";
        self.customerListReverse = false;
        self.isFromAra = !!self.isFromAra || false;
        self.isFromAraUtenze = !!self.isFromAraUtenze || false;
        self.configObj.isCustomerListAra = false;
        self.isFinancial = "YES";
        self.bindingNdg = "";
        self.bindingUserName = null;

        self.level = 0;
        self.functionId = "TIPO_UTENZA";
        self.restIsPending = true;
        self.getUserType();
        self.modifyInfo = false
      };

      self.researchObj = {
        piva: null,
        cf: null,
        ragSoc: null,
        ndg: null,
        identifierType: null,
      };

      self.updatedUserInfo = {
        email: null,
        tel: null,
        name: null,
        surname: null,
        identifier: null,
        bankCode: null,
        idUser: null
      }

      /** Use is to store model related informationchObjs **/

      self.context = $rootScope.context;

      self.getCustomerList = function () {
        //if from footer, do not validate inputs
        if (!validateInput() || self.loading) return;

        self.loading = true;
        self.searchReturned = false;
        $searchUserService
          .getCustomerList(getResearchObj())
          .then(function (customerList) {
            self.loading = false;
            self.searchReturned = true;
            self.customerList = customerList;
            if (self.customerList.length === 1) {
              self.setSelectedAppCustomerUser(self.customerList[0]);
            }
            self.prepareNewAppCustomerFormIfnotExists();
            self.customerList = addEmptyRow(self.customerList);
          });
      };
      self.prepareNewAppCustomerFormIfnotExists = function () {
        if (
          !self.configObj.searchResultWithoutNewUser &&
          (self.customerList == null || self.customerList.length == 0)
        ) {
          $rootScope.$broadcast("addAlert", {
            text: "NO_RESULT_FROM_GETTESTATA_NSIL",
          });
          self.configObj.showNewAppCustomerForm = true;

          self.configObj.selectedAppCustomerUser = {
            identifier: self.researchObj.piva,
            ragSoc: self.researchObj.ragSoc,
            metadata: {
              riUserG: {
                fatturazione: {
                  fatturazioneElettronica: {
                    cdDestinatarioFatturazione: self.researchObj.cdDestinatarioFatturazione,
                    riferimentoAmministrativo: self.researchObj.riferimentoAmministrativo,
                    emailFatturazioneElettronica: self.researchObj.emailFatturazioneElettronica,
                  },
                },
              },
            },
          };
        }
      };

      self.araOnClickDeleteChip = function (customer) {
        self.configObj.customerListAra = self.configObj.customerListAra.filter(
          function isElemUnchecked(elem) {
            return elem.identifier != customer.identifier;
          }
        );
        customer.disableAddIcon = false;
        if (self.configObj.customerListAra.length == 0) {
          self.configObj.isCustomerListAra = false;
        }
      };

      self.araOnClick = function (customer) {
        if (self.configObj.customerListAra.length > 10) {
          $rootScope.$broadcast("addAlert", {
            text: "MAX_CUSTOMER",
          });
        } else {
          self.configObj.customerListAra.push(customer);
          customer.disableAddIcon = true;
          self.configObj.isCustomerListAra = true;

          var customerRagSoc = self.configObj.customerListAra.map(function (
            customer
          ) {
            return customer.name;
          });

          self.configObj.customerListAraRagSoc = customerRagSoc.join(" ");
        }
        return;
      };

      self.setSelectedAppCustomerUser = function (customer) {
        if (!Object.keys(customer).length) {
          self.customerList.forEach(function (customer) {
            customer.selected = false;
          })
          return;
        }
        if (customer.deleted) {
          $modalService.openModal("deletedCustomerModalLO");
        }
        if (!customer.selected) {
          for (var i = 0; i < self.customerList.length; i++) {
            self.customerList[i].selected = false;
          }
          customer.selected = true;
          self.configObj.selectedAppCustomerUser = customer;

          if (self.configObj.searchResultWithoutNewUser) {
            FactoryObj.selectedAppVendorUser = customer;
          } else {
            FactoryObj.selectedAppCustomerUser = customer;
          }
        } else {
          return;
        }
      };

      $rootScope.$on("goBackToCustomerDetails", function (event, args) {
        self.configObj.fromContractDocumentsView = true;
        self.saveAppCustomerGfromSearch();
      });

      self.validateForm = function () {
        return true;
      };

      self.saveAppCustomerGfromSearch = function () {
        if (self.configObj.showNewAppCustomerForm && !self.validateForm()) {
          $rootScope.$broadcast("addAlert", {
            text: "SEARCH_INVALID_FIELDS",
          });
          return;
        }

        self.loading = true;

        if (
          !self.configObj.fromContractDocumentsView &&
          self.configObj.prefix
        ) {
          self.configObj.selectedAppCustomerUser.phone =
            self.configObj.prefix +
            "/" +
            self.configObj.selectedAppCustomerUser.phone;
        }

        $searchUserService
          .saveAppCustomerGfromSearch(self.configObj.selectedAppCustomerUser)
          .then(function (savedAppCustomerUser) {
            self.loading = false;
            if (savedAppCustomerUser) {
              self.configObj.selectedAppCustomerUser = savedAppCustomerUser;

              if (
                self.configObj.fromSimulation &&
                !self.configObj.selectedAppCustomerUser.email
              ) {
                $rootScope.$broadcast("addAlert", {
                  text: "SEARCHCOSTUMER_ARF_NO_EMAIL",
                });
                //return;
              }

              self.configObj.showDetailedView = true;
              self.configObj.showOnlyInfoDetails = false;
              self.configObj.showNewAppCustomerForm = false;

              FactoryObj.insertAppSimulationFnInput =
                self.configObj.selectedAppCustomerUser.identifier;
              self.filterAllSimulations.appSimulation.identifierAppCustomer =
                self.configObj.selectedAppCustomerUser.identifier;

              $rootScope.$broadcast("refreshInsertAppSimulationFnInput", {});
              getListAppSimulation();
              if (
                !self.configObj.fromContractDocumentsView &&
                self.configObj.fromSimulation
              ) {
                $scope.$emit("autowireSimulationToCustomer", {});
              }
              $rootScope.$broadcast("refreshListAppContract", {
                identifierAppCustomer: self.configObj.selectedAppCustomerUser.identifier,
              });
            } else {
              var splittedPhone = self.configObj.selectedAppCustomerUser.phone.split(
                "/"
              );
              self.configObj.selectedAppCustomerUser.phone =
                splittedPhone[splittedPhone.length - 1];
            }
          });
      };
      self.goToInfoAppCustomer = function () {
        self.loading = true;
        self.configObj.selectedAppCustomerUser.searchResultWithoutNewUser =
          self.configObj.searchResultWithoutNewUser;
        $searchUserService
          .saveAppCustomerGfromSearch(self.configObj.selectedAppCustomerUser)
          .then(function (savedAppCustomerUser) {
            self.loading = false;
            if (
              savedAppCustomerUser &&
              savedAppCustomerUser.email != null &&
              savedAppCustomerUser.email.trim() != ""
            ) {
              self.configObj.selectedAppCustomerUser = savedAppCustomerUser;
              self.configObj.showDetailedView = false;
              self.configObj.showOnlyInfoDetails = true;
              self.configObj.showNewAppCustomerForm = false;
              $rootScope.$broadcast("syncSelectedVendor", {});
            } else {
              $rootScope.$broadcast("addAlert", {
                text: "SEARCHCOSTUMER_ARA_NO_EMAIL",
              });
            }
          });
      };

      self.goToManagementAppCustomer = function () {
        self.loading = true;
        self.configObj.selectedAppCustomerUser.searchResultWithoutNewUser =
          self.configObj.searchResultWithoutNewUser;
        self.loading = false;
        self.configObj.selectedAppCustomerUser = {};
        self.configObj.showDetailedView = false;
        self.configObj.showOnlyInfoDetails = true;
        self.configObj.showNewAppCustomerForm = false;
      };
      self.goBackToSearchForm = function () {
        self.loading = false;
        self.configObj.selectedAppCustomerUser = null;
        self.configObj.showDetailedView = false;
        self.configObj.showOnlyInfoDetails = false;
        self.configObj.showNewAppCustomerForm = false;
        self.searchReturned = false;
        self.researchObj.piva = null;
        self.researchObj.cf = null;
        self.researchObj.ragSoc = null;
        self.researchObj.ndg = null;
        self.modifyInfo = false;
        self.setSelectedAppCustomerUser({})
        self.getCustomerListAra()
      };

      self.isUserFormValid = function () {
        if (
          !self.configObj.selectedAppCustomerUser.identifier ||
          !self.configObj.selectedAppCustomerUser.ragSoc ||
          !self.configObj.selectedAppCustomerUser.email ||
          !self.configObj.prefix ||
          !self.configObj.selectedAppCustomerUser.phone
        ) {
          return false;
        }
        return true;
      };

      var getResearchObj = function () {
        if (self.researchObj.piva) {
          self.researchObj.identifierType = "piva";
          self.researchObj.identifier = self.researchObj.piva;
        } else if (self.researchObj.cf) {
          self.researchObj.identifierType = "cf";
          self.researchObj.identifier = self.researchObj.cf;
        } else if (self.researchObj.ndg) {
          self.researchObj.identifierType = "ndg";
          self.researchObj.identifier = self.researchObj.ndg;
        } else if (self.researchObj.ragSoc) {
          self.researchObj.identifierType = null;
          self.researchObj.identifier = null;
        }

        self.researchObj.searchResultWithoutNewUser =
          self.configObj.searchResultWithoutNewUser;

        return self.researchObj;
      };

      var validateInput = function () {
        if (
          !self.researchObj.piva &&
          !self.researchObj.cf &&
          !self.researchObj.ndg &&
          !self.researchObj.ragSoc
        ) {
          $rootScope.$broadcast("addAlert", {
            text: "LOGIN_LANDINGPAGE_003",
          });
        }
        return (
          self.researchObj.piva ||
          self.researchObj.cf ||
          self.researchObj.ndg ||
          self.researchObj.ragSoc
        );
      };

      self.customerListSortFunction = function (headerName, headerOrder) {
        self.customerListSortKey = headerName;
        if (headerOrder == "up") {
          self.customerListReverse = false;
        } else {
          self.customerListReverse = true;
        }
      };

      self.hideSortArrow = function (headerName, headerOrder) {
        if (self.customerListSortKey == headerName) {
          if (headerOrder == "up" && self.customerListReverse == false) {
            return true;
          }
          if (headerOrder == "down" && self.customerListReverse == true) {
            return true;
          }
        }
        return false;
      };

      if ($configService.getUser().type == "VENDOR_AGENT") {
        self.filterAllSimulations = {
          appSimulation: {
            limit: "10",
            offset: 0,
            pageIndex: 1,
            totalPages: 0,
            orderColumnName: "UPDATE_DATE",
            orderType: "DESC",
            pivaCustomer: null,
          },
        };
      } else {
        self.filterAllSimulations = {
          appSimulation: {
            limit: "10",
            offset: 0,
            pageIndex: 1,
            totalPages: 0,
            orderColumnName: "UPDATE_DATE",
            orderType: "DESC",
            identifierAppCustomer: null,
            identifierAppVendor: null,
          },
        };
      }

      self.foundPerson = {
        identifier: null,
        cf: null,
        email: null,
        piva: null,
        ragSoc: null,
        phone: null,
      };

      /** Set true only if the search method retrieved a user */
      self.userFound = false;

      /** Used to transform input fields into lebels (ng-hide / ng-show) */
      self.newUserInserted = false;

      /** Used to disable input fields for the identifier */
      self.disableIdentifierInputs = false;

      /** If fields are ok enable this, cant call the insert! */
      self.disableInsertButton = false;

      /** True if the first search has been pressed */
      self.listSearched = false;

      $rootScope.$on("refreshListAppSimulation", function (event, args) {
        getListAppSimulation();
      });

      self.checkNotNull = function (codeValue, objStringToCheck) {
        if (objStringToCheck) {
          return $filter("translate")(codeValue);
        }
        return null;
      };

      /** Extract information from metadata and return a string with a list of product infos **/
      self.prepareGoodTypeBrandConcat = function (metadata) {
        try {
          if (metadata != null) {
            // consider only not empty row!
            var metadataObj = metadata;
            var finalConcatString = "";
            if (
              metadataObj.leasingObj != null &&
              metadataObj.leasingObj.leasingItems != null &&
              metadataObj.leasingObj.leasingItems.length > 0
            ) {
              for (
                var index = 0; index < metadataObj.leasingObj.leasingItems.length; index++
              ) {
                var prodItem = metadataObj.leasingObj.leasingItems[index];
                var separator = ", ";
                if (finalConcatString.length == 0) {
                  separator = "";
                }
                finalConcatString +=
                  separator + prodItem.brand + " " + prodItem.goodType;
              }
            }
            return finalConcatString;
          }
        } catch (e) {
          return "";
        }
      };

      self.goToRiViews = function (simulationItem) {
        // to get ARA working - 18/09/2018
        var idx;
        if ($rootScope.portalName == "ILEAF_ARA")
          idx = simulationItem.identifierAppVendor;
        // idx = $configService.getUser().identifier;
        else
          idx =
            $configService.getUser().type == "VENDOR_AGENT" ?
              simulationItem.identifierAppVendor :
              $configService.getUser().identifier;
        $monitoringService
          .getChartData(["app.kpi.plafondChart"], idx, null)

          //               $monitoringService.getChartData(['app.kpi.plafondChart'], $configService.getUser().identifier, null)
          .then(function (res) {
            var availablePlafond = res.listAppKpi[0].kpiValue.dataset[1];
            FactoryObj.selectedUserG = self.configObj.selectedAppCustomerUser;
            FactoryObj.simulationItem = simulationItem;
            var vr =
              FactoryObj.simulationItem.metadata.leasingObj.leasingPrice.vr;
            if (typeof vr != "undefined" && vr != null) {
              if (availablePlafond > vr) {
                $rootScope.$broadcast("goToRiViews", {});
              } else {
                //ERROR
                $rootScope.$broadcast("addAlert", {
                  text: "ERROR_PLAFOND_002",
                });
              }
            } else {
              //ERROR
              $rootScope.$broadcast("addAlert", {
                text: "ERROR_PLAFOND_002",
              });
            }
          });
      };

      //To retrieve all the simulations
      var getListAppSimulation = function () {
        // if coming from ARA, set the identifier as the selected vendor

        if ($configService.getUser().type == "VENDOR_AGENT") {
          if (self.configObj.selectedAppCustomerUser.identifier) {
            self.filterAllSimulations.appSimulation.pivaCustomer =
              self.configObj.selectedAppCustomerUser.identifier;
          }
          $simulationService
            .getAllSimulationsByFilter(self.filterAllSimulations)
            .then(function (response) {
              var totalCount = response.totalCount;
              self.filterAllSimulations.appSimulation.totalPages = getSTotalPages(
                totalCount
              );
              $scope.listSimulationsLen = response.totalCount;
              var simulationList = response.allListAppSimulation;

              self.searchUserObj.simulationList = [];
              self.searchUserObj.simulationList = addEmptyRow(simulationList);
            })
            .finally(function () {
              $scope.searching = false;
            });
        } else {
          if ($rootScope.context == "portal-list/ara/") {
            self.filterAllSimulations.appSimulation.identifierAppVendor =
              FactoryObj.selectedAppVendorUser.ndg;
            //self.filterAllSimulations.appSimulation.identifierAppVendor = $configService.getUser().identifier;
          } else {
            self.filterAllSimulations.appSimulation.identifierAppVendor = $configService.getUser().identifier;
          }

          $simulationService
            .getAllSimulations(self.filterAllSimulations)
            .then(function (response) {
              var simulationList = response && response.listAppSimulation;
              var totalCount = response && response.totalCount;
              //WIP 1,2,3,4,6,12

              self.filterAllSimulations.appSimulation.totalPages = getSTotalPages(
                totalCount
              );

              self.searchUserObj.simulationList = [];
              self.searchUserObj.simulationList = addEmptyRow(simulationList);
            });
        }
      };

      //update table getAllSimulations
      self.updateOrderTableSimulation = function (ordColName, ordType) {
        self.filterAllSimulations.appSimulation.orderColumnName = ordColName;
        self.filterAllSimulations.appSimulation.orderType = ordType;
        getListAppSimulation();
      };

      self.pageSIndexIndietro = function (value) {
        if (value == "init") {
          self.filterAllSimulations.appSimulation.pageIndex = 1;
        } else {
          if (self.filterAllSimulations.appSimulation.pageIndex > 1) {
            self.filterAllSimulations.appSimulation.pageIndex--;
          }
        }
        updateOffsetAndSearch();
      };

      self.pageSIndexAvanti = function (value) {
        if (value == "end") {
          //subito pagina finale
          self.filterAllSimulations.appSimulation.pageIndex =
            self.filterAllSimulations.appSimulation.totalPages;
        } else {
          //avanzo +1
          if (
            self.filterAllSimulations.appSimulation.pageIndex <
            self.filterAllSimulations.appSimulation.totalPages
          ) {
            self.filterAllSimulations.appSimulation.pageIndex++;
          }
        }
        updateOffsetAndSearch();
      };

      function updateOffsetAndSearch() {
        self.filterAllSimulations.appSimulation.offset =
          (self.filterAllSimulations.appSimulation.pageIndex - 1) *
          self.filterAllSimulations.appSimulation.limit;
        getListAppSimulation();
      }

      function getSTotalPages(totalCount) {
        //se il resto è zero non va aggiunto +1
        var addPlusOneToTotal = 0;
        var totModuloResult =
          totalCount % Number(self.filterAllSimulations.appSimulation.limit);
        if (totModuloResult > 0) {
          addPlusOneToTotal = 1;
        }
        return (
          Math.floor(
            totalCount / Number(self.filterAllSimulations.appSimulation.limit)
          ) + addPlusOneToTotal
        );
      }

      function addEmptyRow(restList) {
        try {
          var outputList = [];
          var limit = 0;
          if (restList.length == 1) {
            limit = 4;
          } else {
            limit = self.filterAllSimulations.appSimulation.limit;
          }
          var indexRestList = Number(limit);
          if (restList != null) {
            outputList = restList;
            indexRestList = Number(limit) - restList.length;
          }

          if (indexRestList > 0 && restList.length > 0) {
            for (var irl = 0; irl < indexRestList; irl++) {
              outputList.push({});
            }
          }
          return outputList;
        } catch (e) {
          console.error(e.message);
          return restList;
        }
      }

      /** Open modal to confirm the logic deletion of the simulation **/
      self.openModalDeleteSimulationFromSearch = function (id) {
        self.searchUserObj.selectedSimulationId = id;
        $("#deleteSimulation-inner-component-modal").modal("show");
      };

      /**
       * Called when pressing "send mails" at the end of a simulation
       */
      self.sendSimulationWithAttach = function (idSimulation) {
        var sendEmailWithAttach = {
          appSimulation: {
            id: idSimulation,
          },
        };
        HttpService.send(
          "/simulator/sendSimulationWithAttach",
          sendEmailWithAttach
        ).then(function (response) {
          if (response.success) {
            $rootScope.$broadcast("addAlert", {
              text: "SIM_SENT_EMAIL_OK",
            });
          }
        });
      };

      self.logicDeleteSimulation = function () {
        $simulationService
          .logicDeleteSimulation({
            appSimulation: {
              id: self.searchUserObj.selectedSimulationId,
            },
          })
          .then(function (response) {
            if (response.success) {
              //retrieve simulations
              getListAppSimulation();
            }
          });
      };

      self.generatePostSimulationLink = function (idSimulation) {

        var url = "/simulator/printSimulationDocument/service-infos/" +
          encodeURIComponent(idSimulation) +
          "/";

        $download.getGenericDownload(url)
          .then(function (response) {
            console.log(response);
          })
      };

      /**
       * Called download detail Simulation document
       */

      self.downloadPdfDetailSimulation = function (idSimulation) {
        var url = "/simulator/printContractDetails/service-infos/" +
          encodeURIComponent(idSimulation) +
          "/SIMULATOR/";

        $download.getGenericDownload(url)
          .then(function (response) {
            console.log(response);
          })
      };

      /** search function ARA**/
      self.getCustomerListAra = function () {
        self.configObj.selectedAppCustomerUser = null;
        self.searchReturned = false;
        if (!self.paginationLoading) {
          self.configObj.researchAraVariable.pageIndex = 1
        }
        HttpService.send(
          "/user/search/getAppUser/gestioneUtenze",
          self.configObj.researchAraVariable
        )
          .then(function (response) {
            self.configObj.isLoadingResearch = false;
            self.paginationLoading = false;
            self.searchReturned = true;
            self.customerList = response.listAppUser;
            var totalCount = response.totalCount;
            getSTotalPages(totalCount);
            self.configObj.researchAraVariable.totalPages = Math.ceil(
              totalCount / 10
            );
            self.customerList.forEach(function (customerListCustomer) {
              self.configObj.customerListAra &&
                self.configObj.customerListAra.forEach(function (
                  configObjCustomer
                ) {
                  if (
                    customerListCustomer.identifier ==
                    configObjCustomer.identifier
                  ) {
                    customerListCustomer.disableAddIcon = true;
                  }
                });
            });

            if (self.customerList.length === 1) {
              self.setSelectedAppCustomerUser(self.customerList[0]);
            }
            /** add empty rows to give a structure to table**/
            //self.customerList = addEmptyRow(self.customerList);
          })
          .catch(function (error) {
            self.configObj.isLoadingResearch = false;
            self.paginationLoading = false;
            console.log(error);
          });
      };

      self.pageIndexIndietro = function (value) {
        self.paginationLoading = true;
        if (value == "init") {
          self.configObj.researchAraVariable.pageIndex = 1;
        } else {
          if (self.configObj.researchAraVariable.pageIndex > 1) {
            self.configObj.researchAraVariable.pageIndex--;
          }
        }
        updateOffset();
      };

      self.pageIndexAvanti = function (value) {
        self.paginationLoading = true;
        if (value == "end") {
          self.configObj.researchAraVariable.pageIndex =
            self.configObj.researchAraVariable.totalPages;
        } else {
          if (
            self.configObj.researchAraVariable.pageIndex <
            self.configObj.researchAraVariable.totalPages
          ) {
            self.configObj.researchAraVariable.pageIndex++;
          }
        }
        updateOffset();
      };

      function updateOffset() {
        self.configObj.researchAraVariable.offset =
          (self.configObj.researchAraVariable.pageIndex - 1) *
          self.configObj.researchAraVariable.limit;

        self.getCustomerListAra();
      }

      self.handleIdentifierType = function (type) {
        switch (type) {
          case "ndg":
            self.researchObjAra.identifier = self.bindingNdg;
            break;
          case "userName":
            self.researchObjAra.identifier = self.bindingUserName;
            break;
        }
      };

      self.clickImpersonificaModal = function () {
        self.loaderImpersonifica = true;
        var identifier = self.configObj.appUser.identifier;
        const oldStorage = setOldStorage();
        $userService.superLogin(identifier).then(function (response) {
          $modalService.closeModal("modal-impersonifica");
          window.open(response.urlEncrypted, "_blank");
          self.loaderImpersonifica = false;
          $storageService.setAppConfig(oldStorage);
          location.reload();
        }).catch(function (err) {
          self.loaderImpersonifica = false;
          console.log(err)
        })
      };
      var setOldStorage = function () {
        var tempStorage = JSON.parse(sessionStorage.getItem("alba-appConfig"));
        return tempStorage;
      };

      self.onMouseEnter = function () {
        $(".tooltip").addClass("text-break");
        var copyText = $(".tooltip").text();
        var textarea = document.createElement("textarea");
        document.body.appendChild(textarea);
        textarea.value = copyText;
        textarea.select();
        textarea.setSelectionRange(0, 99999);
        document.execCommand("copy");
        document.body.removeChild(textarea);
      };

      self.goHome = function () {
        $location.path("/");
      }

      self.getUserType = function () {
        $arcService
          .getListTypeUserGestUser()
          .then(function (response) {
            self.restIsPending = false;
            self.userType = response;
            self.userTypeCensus = response.filter(function (type) {
              return type.additionalInfo == 1 || type.description == 'Subagente' || type.description == 'Back office agenti'
            })
          })
          .catch(function (error) {
            self.restIsPending = false;
            console.log(error);
          });
      }

      self.closeModal = function () {
        $modalService.closeModal("modal-impersonifica");
        location.reload();
      }

      self.sendImpersonifica = () => {
        self.loaderImpersonifica = true;
        $userService.loginImpersonifica(
          self.configObj.appUser.identifier,
          self.userLogged.ndg,
          self.userLogged.identifier,
          self.userLogged.type,
          self.userLogged.subType
        )
          .then((response) => {
            console.log(response)
            var link = angular.element("<a/>");
            link.css({
              display: "none",
            });
            link.attr({
              href: response.urlRedirect,
              target: "_blank",
            });
            $timeout(() => {

              link[0].click();
              link.remove();
              self.loaderImpersonifica = false;
              $modalService.closeModal("modal-impersonifica");
            }, 200)
            //location.reload();
          })
          .catch((error) => {
            console.log(error)
            self.loaderImpersonifica = false;
          })

      }
    }
  });